(() => {
  if (window.__rootedAsiaGalleryDelegatedHandler) return;
  window.__rootedAsiaGalleryDelegatedHandler = true;

  const changeGalleryImage = (event) => {
    const target = event.target instanceof Element
      ? event.target
      : event.target && event.target.parentElement instanceof Element
        ? event.target.parentElement
        : null;
    const thumb = target && target.closest('[data-ra-thumb]');
    if (!thumb) return;

    const gallery = thumb.closest('[data-ra-gallery]');
    const mainImage = gallery && (
      gallery.querySelector('[data-ra-main-image]') ||
      gallery.querySelector('.ra-product-gallery__main-img')
    );
    const fullImage = thumb.getAttribute('data-full-img');
    if (!gallery || !mainImage || !fullImage) return;

    event.preventDefault();
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.setAttribute('src', fullImage);
    mainImage.alt = thumb.getAttribute('data-alt') || '';

    gallery.querySelectorAll('[data-ra-thumb]').forEach((candidate) => {
      const active = candidate === thumb;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', changeGalleryImage, true);
})();